export const CK_EDITOR_BASE_CONFIG = {
  toolbar: [
    { name: 'document', items: ['Source'] },
    { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
    {
      name: 'basicstyles',
      items: [
        'Bold',
        'Italic',
        'Underline',
        'Strike',
        'Subscript',
        'Superscript',
        '-',
        'CopyFormatting',
        'RemoveFormat',
      ],
    },
    { name: 'colors', items: ['TextColor', 'BGColor'] },
    {
      name: 'paragraph',
      items: [
        'NumberedList',
        'BulletedList',
        '-',
        'Outdent',
        'Indent',
        '-',
        'Blockquote',
        '-',
        'JustifyLeft',
        'JustifyCenter',
        'JustifyRight',
        'JustifyBlock',
        '-',
        'BidiLtr',
        'BidiRtl',
      ],
    },
    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
    {
      name: 'insert',
      items: [
        'Media',
        'uploadImg',
        'uploadVideo',
        'uploadAudio',
        'Table',
        'HorizontalRule',
        'Smiley',
        'SpecialChar',
        'PageBreak',
        'Iframe',
        'drawShape',
        'fillBlank',
        'selectForm',
        'ckeditor_wiris_formulaEditor',
        'ckeditor_wiris_formulaEditorChemistry',
      ],
    },
  ],
};
